import { render } from "./otp.vue?vue&type=template&id=865904d2&ts=true"
import script from "./otp.vue?vue&type=script&lang=ts"
export * from "./otp.vue?vue&type=script&lang=ts"

import "./otp.vue?vue&type=style&index=0&id=865904d2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__